import { withJsonFormsControlProps, useJsonForms } from '@jsonforms/react';
import { updateErrors } from '@jsonforms/core';
import { CountryGreetingField } from '../CustomComponents/CountryGreetingField';
import type { ControlProps } from '@jsonforms/core';

const CountryGreetingControl = ({
  data,
  handleChange,
  path,
  label,
  schema,
}: ControlProps) => {
  const { dispatch } = useJsonForms();

  const sendError = (errorMessage: string | null) => {
    dispatch?.(
      updateErrors(
        errorMessage
          ? [
              {
                message: errorMessage,
                instancePath: path.startsWith('/') ? path : `/${path}`,
                keyword: 'custom',
                schemaPath: '',
                params: {},
              },
            ]
          : []
      )
    );
  };

  const options = (schema as any)?.['x-options'] || {};
  const languages = options.languages || [];

  return (
    <CountryGreetingField
      value={data || {}}
      label={label ?? schema?.title}
      updateValue={(newValue, error) => {
        handleChange(path, newValue);
        sendError(error);
      }}
      languages={languages}
      config={{
        messageLabel: options.messageLabel ?? 'Greeting',
        languageLabel: options.languageLabel ?? 'Language',
        jsonFieldLabel: options.jsonFieldLabel ?? 'Greeting JSON Object',
        buttonLabel: options.buttonLabel ?? '',
        jsonFieldHint:
          options.jsonFieldHint ?? 'Enter a JSON object: { "en": "Hello" }',
      }}
      classes={{
        autocomplete: 'bg-white',
        chip: 'mt-2',
        iconButton: 'text-main',
        itemBox: 'hover:bg-gray-50',
        helperText: 'm-2 text-small text-gray-500',
        jsonInput: 'text-small',
      }}
    />
  );
};

export default withJsonFormsControlProps(CountryGreetingControl);
